import { ChangeEvent, FC } from 'react'
import { useCustomTheme } from '@/core/theme'
import { ActionButton } from '@/ui/components/buttons/action'
import Typography from '@/ui/components/typography'
import {
    ButtonsWrapper,
    CommentInput,
    FooterWrapper,
    SecondaryButton,
    SelectedCountWrapper,
} from './IssueDrawerFooter.styles'
import { IssueDrawerFooterProps } from './IssueDrawerFooter.types'

const COMMENT_LENGTH_LIMIT = 300

const IssueDrawerFooter: FC<IssueDrawerFooterProps> = ({
    resolution,
    selectedCount,
    hasSelectableAssets,
    selection,
}) => {
    const theme = useCustomTheme()

    const { comment, setComment, submitFixed, submitNotAnIssue, loading } =
        resolution
    const loadingText = resolution.scanInProgress
        ? 'Scan in progress...'
        : 'Validating...'

    const isMarkFixedDisabled =
        loading ||
        comment.trim() === '' ||
        (hasSelectableAssets && selectedCount === 0)
    const isNotAnIssueDisabled = loading || comment.trim() === ''

    return (
        <FooterWrapper data-testid="drawer-footer-actions">
            {hasSelectableAssets && (
                <SelectedCountWrapper>
                    <Typography
                        variant="m-regular"
                        color={theme.colors.greys[700]}
                        testId="selected-assets-count"
                    >
                        {`${selectedCount} Asset${
                            selectedCount === 1 ? '' : 's'
                        } selected`}
                    </Typography>
                </SelectedCountWrapper>
            )}
            <CommentInput
                type="text"
                aria-label="Add a comment (required)"
                placeholder="Add a comment (required)"
                data-testid="issue-resolution-comment"
                value={comment}
                maxLength={COMMENT_LENGTH_LIMIT}
                disabled={loading}
                onChange={(event: ChangeEvent<HTMLInputElement>) =>
                    setComment(event.target.value)
                }
            />
            <ButtonsWrapper>
                <ActionButton
                    disabled={isMarkFixedDisabled}
                    loading={loading}
                    onClick={() => submitFixed(selection)}
                    dataTestId="mark-as-fixed-button"
                    fontWeight="regular"
                    text={loading ? loadingText : 'Mark as Fixed'}
                />
                <SecondaryButton
                    type="button"
                    data-testid="not-an-issue-button"
                    disabled={isNotAnIssueDisabled}
                    onClick={() => submitNotAnIssue(selection)}
                >
                    Not an Issue
                </SecondaryButton>
            </ButtonsWrapper>
        </FooterWrapper>
    )
}

export default IssueDrawerFooter
